import { useState } from "react";
import cn from "classnames";

import { useDebounce } from "hooks/useDebounce";
import IMagnifier from "assets/i-magnifier.js";

const Search = ({ delay = 500, onChange, containerClassName, inputClassName, ...props }) => {
  const [search, setSearch] = useState("");

  const { debounceFn } = useDebounce({
    onChange: (query) => {
      onChange?.(query);
    },
    delay,
  });

  return (
    <div
      className={cn(
        "h-[24px] p-2 flex items-center gap-1 rounded-[4px] border-[1px] border-solid border-[#D8D8D9] w-[200px]",
        containerClassName,
        props.disabled && "opacity-50 cursor-not-allowed",
      )}
    >
      <IMagnifier />
      <input
        className={cn(
          "h-[24px] py-2 text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526] w-full placeholder:text-[#808285]",
          inputClassName,
        )}
        onChange={(e) => {
          setSearch(e.target.value);
          debounceFn(e.target.value);
        }}
        value={search}
        {...props}
      />
    </div>
  );
};

export default Search;
